import { stringifyUrl, parseUrl, parse, ParsedQuery, pick, stringify } from 'query-string'
import { FilterQueryParam } from '../../utils/search/filter-query-param-util/query-params'
import { Channel } from '@at/sauron-platform-core'
import { getSearchUrlAdvertisingLocation } from '@at/formatter-utils/lib/channel-utils/channel.util'

const validFilterQueryParams = Object.values(FilterQueryParam)

const addMissingParams = (queryParams: ParsedQuery, channel: Channel, isLeasingSearch: boolean): ParsedQuery => {
    if (isLeasingSearch) {
        return {
            ...queryParams,
            fromsra: null,
        }
    } else {
        const mergeIntoExistingAdvertisingLocations = (advertisingLocations: string[]) =>
            advertisingLocations
                .filter((value) => value !== getSearchUrlAdvertisingLocation(channel))
                .concat([getSearchUrlAdvertisingLocation(channel)])

        const advertisingLocations = Array.isArray(queryParams[FilterQueryParam.advertising_location])
            ? mergeIntoExistingAdvertisingLocations(queryParams[FilterQueryParam.advertising_location] as string[])
            : getSearchUrlAdvertisingLocation(channel)

        return {
            ...queryParams,
            [FilterQueryParam.advertising_location]: advertisingLocations,
            fromsra: null,
        }
    }
}

function getBackLinkQueryParams(parsedQuery: ParsedQuery) {
    return stringify(
        {
            ...parsedQuery,
            flrfc: 1,
        },
        { sort: false }
    )
}

const updatePageNumber = (clientQueryParams: ParsedQuery<string>, pageNumber: number): ParsedQuery<string> => {
    return {
        ...clientQueryParams,
        [FilterQueryParam.page]: pageNumber.toString(),
    }
}

const setFinanceCalculatorTerm = (parsedQuery: ParsedQuery<string>, termMonths: string) => {
    return {
        ...parsedQuery,
        [FilterQueryParam.calc_term]: termMonths,
    }
}
const setFinanceCalculatorDeposit = (parsedQuery: ParsedQuery<string>, initialPayment: string) => {
    return {
        ...parsedQuery,
        [FilterQueryParam.calc_deposit]: initialPayment,
    }
}
const setFinanceCalculatorMileage = (parsedQuery: ParsedQuery<string>, mileage: string) => {
    return {
        ...parsedQuery,
        [FilterQueryParam.calc_mileage]: mileage,
    }
}
const updateQueryParams = (
    parsedQuery: ParsedQuery<string>,
    pageNumber: number | undefined,
    termMonths: string | null | undefined,
    initialPayment: string | null | undefined,
    mileage: string | null | undefined
) => {
    if (pageNumber !== undefined) {
        parsedQuery = updatePageNumber(parsedQuery, pageNumber)
    }
    if (termMonths !== undefined && termMonths !== null) {
        parsedQuery = setFinanceCalculatorTerm(parsedQuery, termMonths)
    }
    if (initialPayment !== undefined && initialPayment !== null) {
        parsedQuery = setFinanceCalculatorDeposit(parsedQuery, initialPayment)
    }
    if (mileage !== undefined && mileage !== null) {
        parsedQuery = setFinanceCalculatorMileage(parsedQuery, mileage)
    }

    return parsedQuery
}
export const buildFpaUrl = (
    fpaLink: string,
    search: string,
    channel: Channel,
    isLeasingSearch: boolean,
    pageNumber?: number,
    termMonths?: string | null,
    initialPayment?: string | null,
    mileage?: string | null
) => {
    const urlFromServer = parseUrl(fpaLink, { sort: false })
    const parsedQuery = parse(search, { sort: false })
    const clientQueryParams = updateQueryParams(parsedQuery, pageNumber, termMonths, initialPayment, mileage)
    const clientUrl = stringifyUrl({ url: urlFromServer.url, query: clientQueryParams })
    const cleanedClientUrl = pick(clientUrl, validFilterQueryParams)
    const parsedClientUrl = parseUrl(cleanedClientUrl)
    const cleanedQueryParams = addMissingParams(parsedClientUrl.query, channel, isLeasingSearch)
    if (clientQueryParams.retailerId) {
        cleanedQueryParams.fromDealerSearchResults = null
    }
    const backLinkQueryParams = getBackLinkQueryParams(parsedQuery)
    return stringifyUrl(
        {
            url: urlFromServer.url,
            query: {
                ...urlFromServer.query,
                ...cleanedQueryParams,
                backLinkQueryParams: backLinkQueryParams,
            },
        },
        { sort: false }
    )
}
